<app-card
  title="Listado de interacciones"
  [link]="'/interactions/new-interaction'"
  [titleRouter]="titleButton"
>
</app-card>
